<template>
  <main class="urunler-page">
    <section class="hero">
      <div class="hero-inner">
        <div class="hero-copy">
          <p class="eyebrow">Gübre Ürünleri</p>
          <h1>Farklı ihtiyaçlar için dengeli besleme çözümleri</h1>
          <p class="lead">
            Organik, sıvı kimyevi ve katı gübre portföyümüz; toprak ve bitki ihtiyacına göre formüle edildi. May Tohum
            çeşitleriyle birlikte düşünüldüğünde üreticiye ekimden hasada tamamlayıcı bir plan sunuyoruz.
          </p>
          <div class="filters">
            <button
              v-for="kategori in kategoriler"
              :key="kategori"
              :class="['filter-chip', { active: aktifKategori === kategori }]"
              @click="aktifKategori = kategori"
            >
              {{ kategori }}
            </button>
            <router-link to="/tohumlar" class="seed-link">May Tohum Tohumları</router-link>
          </div>
        </div>
      </div>
    </section>

    <section class="grid-section">
      <div class="grid">
        <ProductTile
          v-for="(product, index) in filtreliUrunler"
          :key="index"
          :product="product"
        />
      </div>
    </section>
  </main>
</template>

<script>
import ProductTile from './ProductTile.vue';
import productsData from '../assets/products_new.json';

export default {
  name: 'AppUrunler',
  components: {
    ProductTile
  },
  data() {
    return {
      products: productsData.products,
      aktifKategori: 'Hepsi'
    };
  },
  computed: {
    kategoriler() {
      const set = new Set(['Hepsi']);
      this.products.forEach((p) => {
        if (p.role) set.add(p.role);
      });
      return Array.from(set);
    },
    filtreliUrunler() {
      if (this.aktifKategori === 'Hepsi') return this.products;
      return this.products.filter((p) => p.role === this.aktifKategori);
    }
  }
};
</script>

<style scoped>
.urunler-page {
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  min-height: 100vh;
  display: grid;
  gap: 28px;
  padding: 28px 0 56px;
}

.hero,
.grid-section {
  width: var(--page-width);
  margin: 0 auto;
  box-sizing: border-box;
}

.hero-inner {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  padding: 24px;
  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.08);
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}

.hero-copy {
  display: grid;
  gap: 12px;
  color: #0f172a;
}

.eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  font-weight: 800;
  color: #0f766e;
}

.eyebrow::before {
  content: '';
  width: 18px;
  height: 2px;
  background: #0f766e;
  border-radius: 999px;
}

h1 {
  margin: 0;
  font-size: 28px;
}

.lead {
  margin: 0;
  color: #1f2937;
  line-height: 1.6;
}

.filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.filter-chip {
  border: 1px solid #cbd5e1;
  background: #ffffff;
  color: #0f172a;
  padding: 8px 12px;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.15s ease;
}

.filter-chip:hover {
  border-color: #0f766e;
  color: #0f766e;
  background: #ecfdf3;
}

.filter-chip.active {
  border-color: #0f766e;
  background: #0f766e;
  color: #f8fafc;
  box-shadow: 0 10px 24px rgba(15, 118, 110, 0.2);
}

.seed-link {
  border: 1px solid #0075b8;
  background: #e8f5fc;
  color: #075985;
  padding: 8px 12px;
  border-radius: 10px;
  font-weight: 800;
  text-decoration: none;
  transition: all 0.15s ease;
}

.seed-link:hover {
  border-color: #075985;
  background: #0075b8;
  color: #ffffff;
}

.grid-section {
  display: grid;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
}

@media (max-width: 920px) {
  .hero-inner {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 640px) {
  .urunler-page {
    padding: 18px 0 44px;
    gap: 22px;
  }

  .hero,
  .grid-section {
    width: calc(100% - 24px);
  }

  .hero-inner {
    padding: 18px;
  }
}
</style>
